import axios from 'axios'
import qs from 'qs'
import * as _ from '../util/tools'
import store from '../store'

const localApi = '/api/'
// const remoteApi = 'http://api.zjyumai.com/api/'
// axios 配置
axios.defaults.timeout = 500000
axios.defaults.baseURL = localApi // process.env.NODE_ENV === 'production' ? remoteApi : localApi

// POST传参序列化

axios.interceptors.request.use((config) => {
  let token = localStorage.getItem('token')
  if (config.url.indexOf('wechat/ask') < 0) store.dispatch('setLoadingState', true)
  
  if (token && config.url.indexOf('qiniu.com') < 0 && config.url.indexOf('weixin.qq.com') < 0) {
    config.headers.Authorization = `Bearer ${token}`
    config.headers.post['content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  }
  if ((config.method === 'post' || config.method === 'delete' || config.method === 'put') && config.url.indexOf('qiniu.com') < 0 && config.type !== 'upload') {
    config.data = qs.stringify(config.data)
  }
  config.withCredentials = true
  return config
}, (err) => {
  return Promise.reject(err)
})

// 返回状态判断
axios.interceptors.response.use((res) => {
  // if (res.status >= 300 && res.status < 500) {
  //   _.Alerts({'message': res.data.msg, 'hide': true})
  //   return Promise.reject(res)
  // }
  store.dispatch('setLoadingState', false)
  return res
}, (err) => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误(400)'
        break
      case 401:
        if (store.state.logined) {
          err.message = '未授权，请重新登录(401)'
          store.dispatch('setLoginState', false)
        }
        break
      case 403:
        err.message = '没有操作权限(403)'
        break
      case 404:
        err.message = '请求出错(404)'
        break
      case 408:
        err.message = '请求超时(408)'
        break
      case 500:
        if (store.state.logined) {
          store.dispatch('logined', false)
          // Trying to get property of non-object
          _.Alerts({'message': '请求错误，请刷新页面重试！', 'hide': true})
        }
        break
      case 422:
        var errors = err.response.data.error.errors
        for (let k in errors) {
          _.Alerts({'message': errors[k][0], 'hide': true})
        }
        break
      case 501:
        err.message = '服务未实现(501)'
        break
      case 502:
        err.message = '网络错误(502)'
        break
      case 503:
        err.message = '服务不可用(503)'
        break
      case 504:
        err.message = '网络超时(504)'
        break
      case 505:
        err.message = 'HTTP版本不受支持(505)'
        break
      default:
        err.message = `连接出错(${err.response.status})!`
    }
  } else {
    err.message = '连接服务器失败!'
  }
  // message.error(err.message)
  if (err.response && err.response.status !== 500 && err.response.status !== 422) _.Alerts({'message': err.message, 'hide': true})

  return Promise.reject(err)
})

/**
 * fetch 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function fetch (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, params)
    .then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}

export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
    .then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

export function upload (url, formData) {
  return new Promise((resolve, reject) => {
    // let config = {
      // headers: {
      //   'Content-Type': 'multipart/form-data'
      // }
    // }
    axios({
      url: url,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

export function put (url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
    .then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

export function del (url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, params)
    .then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

// export default axios

export default {
  axios,
  /**
   * 用户登录
   */
  Login (params) {
    return post('auth/login', params)
  },

  /**
   * 用户注册
   */
  Register (params) {
    return post('auth/signup', params)
  },
  /**
   * 更新用户资料
   */
  UpdateUser (params) {
    return put('auth/me', params)
  },
  /**
   * 用户
   */
  getUser () {
    return fetch('auth/me')
  },
  /**
   * 获取全国JSON数据
   */
  getAddressJson () {
    return fetch('/api/address')
  }
}
